/** Rutas relativas al prefijo `/facturacion`. */
export const billingPaths = {
  invoices: 'facturas',
  invoiceNew: 'facturas/nueva',
  invoiceDetail: 'facturas/:id',
} as const;
